export function list({ params }) {
  return {
    url: `/api/companies/${params.id}`,
    method: 'GET',
    headers: {
      Accept: 'application/ld+json',
      Authorization: null,
    },
  }
}

export function invite({ payload }) {
  return {
    url: `/api/company_couriers/invite`,
    method: 'POST',
    headers: {
      Accept: 'application/ld+json',
      'Content-Type': 'application/json',
      Authorization: null,
    },
    body: JSON.stringify(payload),
  }
}

export function disable({ params }) {
  return {
    url: `/api/company_couriers/${params.id}/disable`,
    method: 'POST',
    headers: {
      Accept: 'application/ld+json',
      Authorization: null,
    },
  }
}

export function couriers(params) {
  return {
    url: `/api/company_couriers`,
    method: 'GET',
    headers: {
      Accept: 'application/ld+json',
      Authorization: null,
    },
  }
}
